import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import * as R from 'ramda';
import ExternalAuthenticationsComponent from '../components/external-authentications.component';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import PageLoader from '../../../../../../components/PageLoader';
import { selectExternalAuthenticationsQueryItems } from '../../../../../../redux/external-authentications/selector';
import { externalAuthentications } from '../../../../../../redux/external-authentications/action';

export function ManagementExternalAuthentications () {
  const dispatch = useAppDispatch();
	const navigate = useNavigate()
	const extAuthQuery = useSelector(selectExternalAuthenticationsQueryItems)

  const [
    chosenAuthentications,
    setChosenAuthentications
  ] = useState({
    AzureActiveDirectory: {
    },
    Google: {
    },
    FaceBook: {
    },
    Twitter: {
    },
    Linkedin: {
    }
  });

  useEffect(() => {
    (async()=>{
      await dispatch(externalAuthentications.query({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/iam/external-authentications/query`,entity:'externalAuthentication',jsonData:
      {
  
      }
      }))

    })()
  }, []);

  useEffect(() => {
    console.log('extAuthQuery', extAuthQuery)
    if(extAuthQuery?.result?.items){
      console.log('extAuthQuery.result.item', extAuthQuery.result.items)
      setChosenAuthentications(extAuthQuery.result.items)  
    }
  }, [extAuthQuery]);

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setChosenAuthentications({ ...chosenAuthentications, [fields[0]]: value });
  }

  const handleFormSubmit = async (event: any) => {
    await dispatch(externalAuthentications.update({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/iam/external-authentications`,entity:'externalAuthentication',jsonData:
      {
        Records: [
          chosenAuthentications
        ]
      }
      }))
      toast.success('Keys updated successfully.')
      navigate('/management/organization/iam/external-authentications')
  }

  return (
    <>
      {extAuthQuery?.isLoading ? <PageLoader />:
      <ExternalAuthenticationsComponent
          chosenAuthentications={chosenAuthentications}
          handleInnerFormChange={handleInnerFormChange}
          onFormSubmit={handleFormSubmit}
      />
       }
    </>
  );
}
